import { render } from "./Photoshop.vue?vue&type=template&id=9851ac8a"
import script from "./Photoshop.vue?vue&type=script&lang=js"
export * from "./Photoshop.vue?vue&type=script&lang=js"

import "./Photoshop.vue?vue&type=style&index=0&id=9851ac8a&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__